import React, { Component, Fragment } from "react"
import moment from "moment"
import { identity, isNil, isEmpty } from "lodash"
import { MuiThemeProvider } from "@material-ui/core/styles"
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
} from "@material-ui/pickers"
import MomentUtils from "@date-io/moment"
import { pickersTheme } from "../../../themes/main"
import AddressAutoComplete from "../../AddressAutoComplete"
import classNames from "classnames"
import AutoComplete from "../../AutoComplete"
import {
  Typography,
  DialogContent,
  FormControl,
  InputLabel,
  Input,
  Switch,
  Card,
  CardContent,
  Grid,
  Icon,
  Hidden,
  Checkbox,
  Box,
  Avatar,
  Tooltip,
  IconButton,
  Chip,
} from "@material-ui/core"
import { toggleCreateClientDialog } from "../../../actions/users"
import { toggleShootDialog } from "../../../actions/shoots"
import update from "immutability-helper"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "../styles"
import Context from "../context"
import DateFnsUtils from "@date-io/date-fns"
import Image from "../../../assets/images/login_bg.jpg"
import CancelIcon from "@material-ui/icons/Cancel"

import { getRoles } from "../../../actions/misc"

import {
  getCompanyClients,
  toggleAddClientCompanyDialog,
  toggleAddClientDialog,
} from "../../../actions/clients"
import AddClientDialog from "../../AddClientDialog/index"

const locationVal = e => (e ? e + " " : "")

class One extends Component {
  state = {
    switch: false,
    anchorEl: null,
    tbd: true,
    inputValue: "",
  }
  async componentDidMount() {
    this.props.roles.length === 1 && this.props.dispatch(getRoles())
    document.getElementById("shootName").focus()
  }

  selectClient = client => {
    const { context, props } = this
    const { setState, users } = props
    if (client && typeof client.id === "number") {
      const newState = context
      newState.shoot.client = users.find(x => x.id === client.id)
      // { id: 1, full_name: 'pate bryant' }
      setState(newState.shoot.client)
    } else {
      this.props.dispatch(toggleCreateClientDialog(true, {}))
      setState(
        update(context, {
          shoot: {
            client: { $set: client },
          },
        })
      )
    }
    document.getElementById("shoot-location").focus()
  }

  handleDateChange = (date, key) => {
    const { context, props } = this
    const { setState } = props
    if (typeof key === "object") {
      if (this.state.switch) {
        let nextDay = moment(date)
          .add(1, "days")
          .toDate()

        setState(
          update(context, {
            shoot: {
              [key[0]]: {
                $set: date,
              },
              [key[1]]: {
                $set: new Date(new Date(nextDay).toGMTString()),
              },
            },
          })
        )
      } else {
        setState(
          update(context, {
            shoot: {
              [key[0]]: {
                $set: date,
              },
              [key[1]]: {
                $set: date,
              },
            },
          })
        )
      }
    } else {
      setState(
        update(context, {
          shoot: {
            [key]: {
              $set: date,
            },
          },
        })
      )
    }
  }

  handleTimeChange = date => {
    const { context, props } = this
    const { setState } = props
    const time = date.format("YYYY-MM-DD HH:mm:00")
    setState(
      update(context, {
        shoot: {
          call_time: {
            $set: time,
          },
        },
      })
    )
  }

  handleTbdChange = bool => {
    this.setState({ tbd: bool })
    const { context, props } = this
    const { setState } = props
    const time = bool ? null : moment().format("YYYY-MM-DD HH:mm:00")
    setState(
      update(context, {
        shoot: {
          call_time: {
            $set: time,
          },
        },
      })
    )
  }

  setLocation = data => {
    const { context, props } = this
    const { setState } = props

    setState(
      update(context, {
        shoot: {
          location: {
            $set: data,
          },
        },
      })
    )
  }
  handleChange = (e, value) => {
    this.setState({ inputValue: value })
  }
  closeShootDialog = () => {
    this.props.dispatch(toggleShootDialog({ open: false }))
  }

  selectDefaultCrewPosition = async (id, i) => {
    const { context, props } = this
    const { setState, roles } = props
    const role = roles.find(x => x.id === id)

    let roleObject = {
      id: role.id,
      name: role.name,
    }

    setState(
      update(context, {
        shoot: {
          defaultCrews: {
            [i]: {
              shootRole: { $set: roleObject },
            },
          },
        },
      })
    )
  }

  selectAndAddCompany = company => {
    const { props, context } = this
    const { setState } = props
    if (company) {
      if (typeof company === "number") {
        // this.props.dispatch(getCompanyClients(company))
        setState(
          update(context, {
            shoot: {
              client_company: { $set: company },
            },
          })
        )
      } else {
        this.props.dispatch(toggleAddClientCompanyDialog(true))
      }
    } else {
      setState(
        update(context, {
          shoot: {
            client_company: { $set: null },
          },
        })
      )
    }
  }
  selectAndAddCompanyClient = companyClient => {
    const { props, context } = this
    const { setState } = props

    if (companyClient && typeof companyClient === "number") {
      setState(
        update(context, {
          shoot: {
            company_user_id: { $set: companyClient },
          },
        })
      )
    } else if (companyClient && typeof companyClient !== "number") {
      this.props.dispatch(toggleAddClientDialog(true))
    } else {
      setState(
        update(context, {
          shoot: {
            company_user_id: { $set: null },
          },
        })
      )
    }
  }

  render() {
    const { context, props, state } = this
    const {
      classes,
      createdClient,
      createdCompany,
      setState,
      selectedDefaultCrew,
      roles,
      companyClients,
      companyList,
      clientList,
    } = props
    const { shoot } = context

    //try shoot default crew container start
    // const clientCompany = !isEmpty(companyList) && shoot && shoot.client_company ? companyList.find(cl => cl.id === shoot.client_company) : null
    // const foundCompanyClient = !isEmpty(clientList) && shoot && shoot.company_user_id ? clientList.find(ccl => (ccl.id === shoot.company_user_id && ccl.company_id === clientCompany.id)) : null
    // const companyClient = foundCompanyClient ? { id: foundCompanyClient.id, name: foundCompanyClient.first_name + " " + foundCompanyClient.last_name } : null

    const positionCrew = c => {
      return c.map((crew, i) => (
        <Grid
          key={`role-${i + 1}`}
          item
          xs={12}
          sm={6}
          md={6}
          className={classes.padding}
        >
          <Box className={classes.defaultCrewSlate}>
            <Avatar
              className={[classes.purple, classes.large, classes.alignSelf]}
              src={
                crew.profile_image.secure_url
                  ? crew.profile_image.secure_url
                  : Image
              }
            />
            <div className={classes.defaultCrewInfo}>
              <Typography
                component="p"
                className={[
                  classes.noteLineTextDefaultCrew,
                  classes.marginLeft,
                ]}
              >
                {crew.first_name + " " + crew.last_name}
              </Typography>
              {crew.shootRole && crew.shootRole.id ? (
                <Tooltip title="Remove Position" placement="top">
                  <Typography
                    component="p"
                    className={[
                      classes.positionText,
                      classes.marginLeft,
                      classes.pointer,
                    ]}
                    onClick={e =>
                      setState(
                        update(context, {
                          shoot: {
                            defaultCrews: {
                              [i]: {
                                shootRole: { $set: null },
                              },
                            },
                          },
                        })
                      )
                    }
                  >
                    {crew.shootRole && crew.shootRole.name}
                  </Typography>
                </Tooltip>
              ) : (
                <div style={{ minWidth: "180px" }}>
                  <AutoComplete
                    placeholder="Search Position"
                    // onChange={this.selectPosition}
                    onChange={value => this.selectDefaultCrewPosition(value, i)}
                    suggestions={roles}
                    labelKey="name"
                    showValue
                    // value={newPosition.position}
                    prop={this.props}
                  />
                </div>
              )}
            </div>
          </Box>
        </Grid>
      ))
    }
    const positions = (data, crew) => {
      const extra = crew ? positionCrew(crew) : []
      // shot selected crew first
      return extra.concat(
        data.map((x, i) => {
          return (
            <div
              key={i}
              style={{
                display: "flex",
                margin: "26px",
                alignItems: "center",
              }}
            >
              <Chip
                avatar={
                  <Avatar
                    className={classes.closeAvatar}
                    onClick={e =>
                      setState(
                        update(context, {
                          shoot: {
                            roles: {
                              $splice: [[i, 1]],
                            },
                          },
                        })
                      )
                    }
                  >
                    <Icon className={classes.closeIcon}>close</Icon>
                  </Avatar>
                }
                color="primary"
                label={x.position && x.position.name}
                style={{ color: "white" }}
              />
            </div>
          )
        })
      )
    }

    // shoot defualt crew container end
    return (
      <Fragment>
        {/* title section */}

        <AddClientDialog />
        <div className={classes.title}>
          <DialogContent className={classes.newShootTitle}>
            <Typography gutterBottom className={classes.white} variant="h6">
              New Shoot
            </Typography>
            <IconButton onClick={() => this.closeShootDialog()}>
              <Icon style={{ color: "white" }}>close</Icon>
            </IconButton>
          </DialogContent>
        </div>
        {/* end title section */}
        {/* main content */}
        <DialogContent style={{ paddingBottom: 30 }}>
          <Grid container spacing={3} style={{ alignItems: "center" }}>
            {/* shoot name input */}
            <Grid item lg={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel htmlFor="shootName">Shoot Name</InputLabel>
                <Input
                  name="shootName"
                  id="shootName"
                  value={context.shoot.name}
                  onChange={e =>
                    setState(
                      update(context, {
                        shoot: { name: { $set: e.target.value } },
                      })
                    )
                  }
                  autoComplete="nope"
                  fullWidth
                />
              </FormControl>
            </Grid>
            {/* end shoot name imput */}
            {/* client autocomplete */}

            {/* <Grid item lg={6} xs={12} style={{ marginTop: "8px" }}>
              <AutoComplete
                value={
                  isNil(createdClient) ? context.shoot.client : createdClient
                }
                showValue
                placeholder="Client (user)"
                onChange={this.selectClient}
                labelKey="full_name"
                isDisabled={!context.inCompany}
                creatable
                formatCreateLabel={value => `Create new client`}
                prop={this.props}
              />
            </Grid> */}

            {/* end client autocomplete */}
            {/* city autocomplete */}
            <Grid item lg={6} xs={12} style={{ marginTop: "2px" }}>
              <AddressAutoComplete
                value={
                  context.shoot.location &&
                  Object.keys(context.shoot.location).length > 0
                    ? `${locationVal(
                        context.shoot.location.street_number
                      )}${locationVal(
                        context.shoot.location.route
                      )}${locationVal(context.shoot.location.city).replace(
                        " ",
                        ", "
                      )}${locationVal(
                        context.shoot.location.state
                      )}${locationVal(context.shoot.location.zip).replace(
                        " ",
                        ""
                      )}`
                    : undefined
                }
                InputProps={{ label: "Shoot Location", id: "shoot-location" }}
                onChange={this.setLocation}
              />
            </Grid>

            {/* Select Company */}

            <Grid item lg={6} xs={12} style={{ marginTop: "8px" }}>
              {!isNil(createdCompany) ? (
                <AutoComplete
                  placeholder="Search Company"
                  value={createdCompany}
                  onChange={value => this.selectAndAddCompany(value)}
                  labelKey="name"
                  blurInputOnSelect
                  backspaceRemovesValue
                  isClearable={true}
                  showValue
                  creatable={this.props.activeCompany}
                  formatCreateLabel={value => `Create new company`}
                  prop={this.props}
                />
              ) : (
                <AutoComplete
                  placeholder="Search Company"
                  onChange={value => this.selectAndAddCompany(value)}
                  labelKey="name"
                  showValue
                  blurInputOnSelect
                  backspaceRemovesValue
                  isClearable={true}
                  creatable={this.props.activeCompany}
                  formatCreateLabel={value => `Create new company`}
                  prop={this.props}
                  //show value if come from solos

                  newValue={
                    this.context.shoot.client_company ||
                    this.context.shoot.client_company_name
                      ? {
                          id: this.context.shoot.client_company,
                          name: this.context.shoot.client_company_name,
                        }
                      : null
                  }
                />
              )}
            </Grid>

            {/* Select company ends here */}
            {/* Select Client */}
            <Grid item lg={6} xs={12} style={{ marginTop: "8px" }}>
              <AutoComplete
                placeholder="Search Company User"
                onChange={value => this.selectAndAddCompanyClient(value)}
                labelKey="name"
                blurInputOnSelect
                backspaceRemovesValue
                isClearable={true}
                showValue
                prop={this.props}
                creatable={this.props.activeCompany}
                formatCreateLabel={value => `Create new company user`}
                //show value if come from solos
                newValue={
                  this.context.shoot.company_user_id ||
                  this.context.shoot.company_user_name
                    ? {
                        id: this.context.shoot.company_user_id,
                        name: this.context.shoot.company_user_name,
                      }
                    : null
                }
              />
            </Grid>
            {/* Select client ends here */}

            {selectedDefaultCrew && (
              <Grid container>
                {positions(context.shoot.roles, context.shoot.defaultCrews)}
              </Grid>
            )}
            {/* end city autocomplete */}
          </Grid>
          <br />
          <br />

          {/* WEB VIEW */}

          <Hidden smDown>
            <Grid container spacing={3}>
              {/* date picker */}
              <Grid
                item
                lg={6}
                xs={12}
                style={{ display: "flex", marginLeft: "-30px" }}
              >
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  {!this.state.switch ? (
                    <Card
                      className={classes.picker}
                      style={{ display: "flex", marginTop: "-13px" }}
                    >
                      <CardContent>
                        <MuiThemeProvider theme={pickersTheme}>
                          {/* <DatePicker
                        label="Date"
                        disablePast
                        value={context.shoot.start_date}
                        onChange={e => {
                          this.handleDateChange(e, ["start_date", "end_date"])
                        }}
                        variant="static"
                      /> */}
                          <KeyboardDatePicker
                            label="Date"
                            autoOk
                            disablePast
                            value={context.shoot.start_date}
                            onChange={e => {
                              this.handleDateChange(e, [
                                "start_date",
                                "end_date",
                              ])
                            }}
                            variant="inline"
                            inputVariant="outlined"
                            format="MM/dd/yyyy"
                          />
                        </MuiThemeProvider>
                      </CardContent>
                    </Card>
                  ) : (
                    <Card className={classes.picker}>
                      <CardContent style={{ display: "flex" }}>
                        <MuiThemeProvider theme={pickersTheme}>
                          <span
                            style={{ marginRight: "20px", marginLeft: "20px" }}
                          >
                            <KeyboardDatePicker
                              disablePast
                              autoOk
                              variant="inline"
                              inputVariant="outlined"
                              label="Start Date"
                              format="MM/dd/yyyy"
                              value={context.shoot.start_date}
                              InputAdornmentProps={{ position: "start" }}
                              onChange={e => {
                                this.handleDateChange(e, [
                                  "start_date",
                                  "end_date",
                                ])
                              }}
                              minDateMessage={`Start date should not be in the past`}
                            />
                          </span>
                          <span>
                            <KeyboardDatePicker
                              minDate={context.shoot.start_date}
                              autoOk
                              variant="inline"
                              inputVariant="outlined"
                              label="End Date"
                              format="MM/dd/yyyy"
                              value={context.shoot.end_date}
                              InputAdornmentProps={{ position: "start" }}
                              onChange={e =>
                                this.handleDateChange(e, "end_date")
                              }
                              minDateMessage={`End date should not be before the start date`}
                            />
                          </span>
                        </MuiThemeProvider>
                      </CardContent>
                    </Card>
                  )}
                </MuiPickersUtilsProvider>
              </Grid>
              {/* end date picker */}
              {/* time picker */}
              <Grid container xs={6}>
                <Grid item lg={4} xs={6}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <Card className={classes.picker}>
                      <CardContent>
                        <MuiThemeProvider theme={pickersTheme}>
                          {state.tbd && <div className={classes.overlay} />}
                          <KeyboardTimePicker
                            style={{ position: "relative" }}
                            clearable
                            label="Start Time"
                            value={state.tbd ? null : context.shoot.call_time}
                            onChange={this.handleTimeChange}
                            // variant="static"
                          />
                        </MuiThemeProvider>
                      </CardContent>
                    </Card>
                  </MuiPickersUtilsProvider>
                </Grid>
                <p style={{ marginTop: "40px" }}>to</p>
                <Grid item lg={4} xs={6}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <Card className={classes.picker}>
                      <CardContent>
                        <MuiThemeProvider theme={pickersTheme}>
                          {state.tbd && <div className={classes.overlay} />}
                          <KeyboardTimePicker
                            style={{ position: "relative" }}
                            clearable
                            label="End Time"
                            value={state.tbd ? null : context.shoot.call_time}
                            onChange={this.handleTimeChange}
                            // variant="static"
                          />
                        </MuiThemeProvider>
                      </CardContent>
                    </Card>
                  </MuiPickersUtilsProvider>
                </Grid>
                {/* end time picker */}

                {/* end bottom section */}
                {/* timezone section */}
                <Grid item lg={3} xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "40px",
                    }}
                  >
                    <div />
                    <Icon style={{ marginRight: "8px", fontSize: "14px" }}>
                      access_time
                    </Icon>
                    <div
                      style={{ fontSize: "12px", cursor: "pointer" }}
                      onClick={e =>
                        this.setState({ anchorEl: e.currentTarget })
                      }
                    >
                      {context.shoot.timezone}
                    </div>
                  </div>
                </Grid>

                <br />
                <Grid item lg={2} xs={12}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "centre",
                    }}
                  >
                    <Checkbox
                      checked={state.tbd}
                      onChange={() => this.handleTbdChange(!this.state.tbd)}
                      value="TBD"
                      color="primary"
                      inputProps={{ "aria-label": "time to be determined" }}
                      style={{ padding: 0, paddingLeft: 15 }}
                    />
                    <Typography
                      variant="body1"
                      style={
                        state.tbd
                          ? { fontWeight: "bold" }
                          : { color: "#808080" }
                      }
                    >
                      Time TBD
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>

          {/* MOBILE VIEW */}
          <Hidden mdUp>
            <Grid>
              <Grid container>
                {/* date picker */}

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  {!this.state.switch ? (
                    <Grid item sm={12} style={{ display: "flex" }}>
                      <Card
                        className={classes.picker}
                        style={{ display: "flex", marginTop: "-13px" }}
                      >
                        <CardContent>
                          <MuiThemeProvider theme={pickersTheme}>
                            {/* <DatePicker
                        label="Date"
                        disablePast
                        value={context.shoot.start_date}
                        onChange={e => {
                          this.handleDateChange(e, ["start_date", "end_date"])
                        }}
                        variant="static"
                      /> */}
                            <KeyboardDatePicker
                              label="Date"
                              autoOk
                              disablePast
                              value={context.shoot.start_date}
                              onChange={e => {
                                this.handleDateChange(e, [
                                  "start_date",
                                  "end_date",
                                ])
                              }}
                              variant="inline"
                              inputVariant="outlined"
                              format="MM/dd/yyyy"
                            />
                          </MuiThemeProvider>
                        </CardContent>
                      </Card>
                    </Grid>
                  ) : (
                    <Fragment>
                      <Grid item sm={12} style={{ display: "flex" }}>
                        <Card className={classes.picker}>
                          <CardContent>
                            <MuiThemeProvider theme={pickersTheme}>
                              <KeyboardDatePicker
                                disablePast
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                label="Start Date"
                                format="MM/dd/yyyy"
                                value={context.shoot.start_date}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={e => {
                                  this.handleDateChange(e, [
                                    "start_date",
                                    "end_date",
                                  ])
                                }}
                                minDateMessage={`Start date should not be in the past`}
                              />
                            </MuiThemeProvider>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item sm={12} style={{ display: "flex" }}>
                        <Card className={classes.picker}>
                          <CardContent>
                            <MuiThemeProvider theme={pickersTheme}>
                              <KeyboardDatePicker
                                minDate={context.shoot.start_date}
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                label="End Date"
                                format="MM/dd/yyyy"
                                value={context.shoot.end_date}
                                InputAdornmentProps={{ position: "start" }}
                                onChange={e =>
                                  this.handleDateChange(e, "end_date")
                                }
                                minDateMessage={`End date should not be before the start date`}
                              />
                            </MuiThemeProvider>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Fragment>
                  )}
                </MuiPickersUtilsProvider>
              </Grid>
              {/* end date picker */}

              {/* single/multiple standby/firm switch */}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "32px",
                  marginBottom: "32px",
                  justifyContent: "space-between",
                }}
              >
                {/* <Typography variant="body2">Shoot Date/Time</Typography> */}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    marginBottom: 20,
                  }}
                >
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: !this.state.switch,
                      [classes.unselectedDay]: this.state.switch,
                    })}
                  >
                    Single Day
                  </Typography>
                  <Switch
                    checked={this.state.switch}
                    onChange={e => {
                      // change back to single day shoot
                      if (this.state.switch) {
                        setState(
                          update(context, {
                            shoot: {
                              end_date: { $set: context.shoot.start_date },
                            },
                          })
                        )
                      } else {
                        setState(
                          update(context, {
                            shoot: {
                              end_date: {
                                $set: moment(context.shoot.start_date)
                                  .add(1, "days")
                                  .toDate(),
                              },
                            },
                          })
                        )
                      }
                      this.setState({ switch: !this.state.switch })
                    }}
                  />
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: this.state.switch,
                      [classes.unselectedDay]: !this.state.switch,
                    })}
                  >
                    Multi Day
                  </Typography>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                  }}
                >
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: !context.shoot.firm,
                      [classes.unselectedDay]: context.shoot.firm,
                    })}
                  >
                    Standby
                  </Typography>
                  <Switch
                    checked={context.shoot.firm}
                    onChange={e => {
                      setState(
                        update(context, {
                          shoot: {
                            firm: {
                              $set: !context.shoot.firm,
                            },
                          },
                        })
                      )
                    }}
                  />
                  <Typography
                    className={classNames("", {
                      [classes.selectedDay]: context.shoot.firm,
                      [classes.unselectedDay]: !context.shoot.firm,
                    })}
                  >
                    Firm
                  </Typography>
                </div>
              </div>

              {/* single/multiple standby/firm switch end*/}

              {/* time picker */}
              <Grid container>
                <Grid item sm={5}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <Card className={classes.picker}>
                      <CardContent>
                        <MuiThemeProvider theme={pickersTheme}>
                          {state.tbd && <div className={classes.overlay} />}
                          <KeyboardTimePicker
                            style={{ position: "relative" }}
                            clearable
                            label="Start Time"
                            value={state.tbd ? null : context.shoot.call_time}
                            onChange={this.handleTimeChange}
                            // variant="static"
                          />
                        </MuiThemeProvider>
                      </CardContent>
                    </Card>
                  </MuiPickersUtilsProvider>
                </Grid>
                <p style={{ marginTop: "40px" }}>to</p>
                <Grid item sm={5}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <Card className={classes.picker}>
                      <CardContent>
                        <MuiThemeProvider theme={pickersTheme}>
                          {state.tbd && <div className={classes.overlay} />}
                          <KeyboardTimePicker
                            style={{ position: "relative" }}
                            clearable
                            label="End Time"
                            value={state.tbd ? null : context.shoot.call_time}
                            onChange={this.handleTimeChange}
                            // variant="static"
                          />
                        </MuiThemeProvider>
                      </CardContent>
                    </Card>
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>
              {/* end time picker */}

              {/* timezone section */}
              <Grid
                container
                style={{
                  justifyContent: "space-between",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <Grid item sm={6}>
                  <div style={{ display: "flex" }}>
                    <Checkbox
                      checked={state.tbd}
                      onChange={() => this.handleTbdChange(!this.state.tbd)}
                      value="TBD"
                      color="primary"
                      inputProps={{ "aria-label": "time to be determined" }}
                      style={{ padding: 0, paddingLeft: 15 }}
                    />
                    <Typography
                      variant="body1"
                      style={
                        state.tbd
                          ? { fontWeight: "bold" }
                          : { color: "#808080" }
                      }
                    >
                      Time TBD
                    </Typography>
                  </div>
                </Grid>

                <Grid item sm={6}>
                  <div style={{ display: "flex" }}>
                    <Icon style={{ marginRight: "8px", fontSize: "14px" }}>
                      access_time
                    </Icon>
                    <div
                      style={{ fontSize: "12px", cursor: "pointer" }}
                      onClick={e =>
                        this.setState({ anchorEl: e.currentTarget })
                      }
                    >
                      {context.shoot.timezone}
                    </div>
                  </div>
                </Grid>
              </Grid>

              {/* Halfday/Fullday Section */}

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 20,
                }}
              >
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: context.shoot.day === "half",
                    [classes.unselectedDay]: context.shoot.day !== "half",
                  })}
                >
                  Half Day
                </Typography>
                <Switch
                  color="primary"
                  checked={context.shoot.day === "full"}
                  onChange={e =>
                    setState(
                      update(context, {
                        shoot: {
                          day: {
                            $set:
                              context.shoot.day === "full" ? "half" : "full",
                          },
                        },
                      })
                    )
                  }
                />
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: context.shoot.day === "full",
                    [classes.unselectedDay]: context.shoot.day !== "full",
                  })}
                >
                  Full Day
                </Typography>
              </div>
            </Grid>
          </Hidden>
          {/* end timezone section */}
          {/* day selection */}
          {/* WEB VIEW */}

          {/* end top section */}
          {/* toggles section */}
          {/* WEB VIEW */}
          <Hidden smDown>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                marginTop: "16px",
              }}
            >
              <Typography
                className={classNames("", {
                  [classes.selectedDay]: context.shoot.day === "half",
                  [classes.unselectedDay]: context.shoot.day !== "half",
                })}
              >
                Half Day
              </Typography>
              <Switch
                color="primary"
                checked={context.shoot.day === "full"}
                onChange={e =>
                  setState(
                    update(context, {
                      shoot: {
                        day: {
                          $set: context.shoot.day === "full" ? "half" : "full",
                        },
                      },
                    })
                  )
                }
              />
              <Typography
                className={classNames("", {
                  [classes.selectedDay]: context.shoot.day === "full",
                  [classes.unselectedDay]: context.shoot.day !== "full",
                })}
              >
                Full Day
              </Typography>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "12px",
                marginBottom: "32px",
                justifyContent: "space-between",
              }}
            >
              {/* <Typography variant="body2">Shoot Date/Time</Typography> */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: !this.state.switch,
                    [classes.unselectedDay]: this.state.switch,
                  })}
                >
                  Single Day
                </Typography>
                <Switch
                  color="primary"
                  checked={this.state.switch}
                  onChange={e => {
                    // change back to single day shoot
                    if (this.state.switch) {
                      setState(
                        update(context, {
                          shoot: {
                            end_date: { $set: context.shoot.start_date },
                          },
                        })
                      )
                    } else {
                      setState(
                        update(context, {
                          shoot: {
                            end_date: {
                              $set: moment(context.shoot.start_date)
                                .add(1, "days")
                                .toDate(),
                            },
                          },
                        })
                      )
                    }
                    this.setState({ switch: !this.state.switch })
                  }}
                />
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: this.state.switch,
                    [classes.unselectedDay]: !this.state.switch,
                  })}
                >
                  Multi Day
                </Typography>
              </div>
              <div style={{ display: "flex" }}>
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: !context.shoot.firm,
                    [classes.unselectedDay]: context.shoot.firm,
                  })}
                >
                  Standby
                </Typography>
                <Switch
                  checked={context.shoot.firm}
                  onChange={e => {
                    setState(
                      update(context, {
                        shoot: {
                          firm: {
                            $set: !context.shoot.firm,
                          },
                        },
                      })
                    )
                  }}
                />
                <Typography
                  className={classNames("", {
                    [classes.selectedDay]: context.shoot.firm,
                    [classes.unselectedDay]: !context.shoot.firm,
                  })}
                >
                  Firm
                </Typography>
              </div>
            </div>
          </Hidden>

          {/* bottom section */}

          <FormControl fullWidth>
            <InputLabel htmlFor="shootDescription">
              Shoot Description
            </InputLabel>
            <Input
              name="shootdescription"
              multiline
              margin="normal"
              value={context.forward_facing_text}
              onChange={e =>
                setState(
                  update(context, {
                    shoot: { forward_facing_text: { $set: e.target.value } },
                  })
                )
              }
              autoComplete="nope"
              fullWidth
            />
          </FormControl>
          <br />
          <br />
          <FormControl fullWidth>
            <InputLabel htmlFor="PrivateNotes">PrivateNotes</InputLabel>
            <Input
              name="privatenotes"
              value={context.creator_text}
              multiline
              margin="normal"
              onChange={e =>
                setState(
                  update(context, {
                    shoot: { creator_text: { $set: e.target.value } },
                  })
                )
              }
              autoComplete="nope"
              fullWidth
            />
          </FormControl>
        </DialogContent>
        {/* end main content */}
      </Fragment>
    )
  }
}

One.contextType = Context
// controlls disabled prop of next/save button
One.allowNext = state => {
  const { shoot } = state
  if (shoot.defaultCrews && shoot.defaultCrews.length > 0) {
    return (
      shoot.name.length === 0 ||
      shoot.location === null ||
      shoot.company_user_id === null ||
      shoot.defaultCrews[0].shootRole === null
    )
  } else {
    return (
      shoot.name.length === 0 ||
      shoot.location === null ||
      shoot.company_user_id === null
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.shoots.showDialog,
    users: state.misc.users,
    createdClient: state.users.createdClient,
    createdCompany: state.clients.createdClientCompany,
    selectedDefaultCrew: state.shoots.dialogCrew,
    roles: state.misc.allRoles,
    activeCompany: state.companies.activeCompany,
    companyClients: state.clients.companyClients,
    companyList: state.clients.companiesList,
    clientList: state.clients.clients,
  }
}

const connector = connect(mapStateToProps)

export default withStyles(styles, { withTheme: true })(connector(One))
